import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SPORTS_PAGE_DATA } from './sportsPageData';
import FlsPageFooter from '../../Components/FlsPageFooter/FlsPageFooter';

const SportsPage = ({ pageKey }) => {
  const navigate = useNavigate();
  const page = SPORTS_PAGE_DATA[pageKey];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${page.title} - Stream Online | Free Live Sports TV`;
  }, [page]);

  const handleChannelClick = (channel) => {
    navigate(channel.id ? `/live-channels?c=${channel.id}` : '/live-channels');
  };

  const handleChannelInfoClick = (channel) => {
    const channelSlug = channel.name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    navigate(`/channel/${channelSlug}`);
  };

  const video = typeof page.video === 'string' ? { id: page.video } : page.video;
  const descriptions = page.descriptions || [page.description];

  return (
    <div className="flsStandalonePage sportsPage" style={{ '--sports-background': `url('${page.background}')` }}>
      <section className="flsHeroSection">
        {video && (
          <div className="heroVideoBg">
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&mute=1&controls=0&loop=1&playlist=${video.id}${video.start !== undefined ? `&start=${video.start}` : ''}${video.end !== undefined ? `&end=${video.end}` : ''}&playsinline=1&showinfo=0&rel=0&enablejsapi=1`}
              title={`${page.title} Background Video`}
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
        <div className="heroBgOverlay"></div>
        <div className="heroContentWrapper">
          <h1 className="heroTitle">{page.title}</h1>
          {descriptions.map((description) => <p key={description} className="heroDesc">{description}</p>)}
          <div className="channelsGrid">
            {page.channels.map(([name, buttonText, logo, id]) => {
              const channel = { id, name, buttonText, logo };
              return (
                <div key={name} className="channelCard">
                  <button
                    className="logoContainer channelLogoLink"
                    type="button"
                    onClick={() => handleChannelInfoClick(channel)}
                    aria-label={`View ${channel.name} details`}
                  >
                    <img src={channel.logo} alt={channel.name} className="channelLogoImg" />
                  </button>
                  <button
                    className="channelCtaBtn"
                    onClick={() => handleChannelClick(channel)}
                    aria-label={channel.buttonText}
                  >
                    {channel.buttonText}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <FlsPageFooter showHowToWatch showDirectory={false} />
    </div>
  );
};

export default SportsPage;
